/* Built In Imports */
import { useState } from 'react';
/* External Imports */
import { Box, Image, Text, Flex, List } from '@chakra-ui/react';
import { nanoid } from 'nanoid';
import Slider from 'react-slick';

/* Internal Imports */
/* Components */
import SectionTitle from '@components/Headings/SectionTitle';
import config from '@config';

/* Services */
/* Styles */
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import { render } from 'datocms-structured-text-to-html-string';
import StructuredTextParser from '@app-ila/components/Utility/StructuredTextParser';

/**
 * Renders the Sannidhi Testimonials content component
 * @param {Object} sectionContent - Data for section
 * @param {string} region - Region of the section
 * @param {string} lang - Language of the section
 * @returns {ReactElement} TestimonialsWithCircularImg content component
 */

const TestimonialsWithCircularImg = ({ sectionContent, region, language }) => {
    
    const [currentSlide, setCurrentSlide] = useState(0);
    const [totalSlides, setTotalSlides] = useState(0);
    const [isSmallScreen, setIsSmallScreen] = useState(false);
    const handleInit = slider => {
        setTotalSlides(sectionContent[1]?.testimonials?.length);
    };
    const NextArrow = props => {
        const { onClick } = props;
        return (
            <Box
                pos="absolute"
                top="38%"
                zIndex="10"
                cursor="pointer"
                bgSize="12px"
                bgColor="#fff"
                border="solid 1px #f4f4f4"
                borderRadius="100%"
                w="62px"
                h="62px"
                boxShadow="0 0 7px 0 rgb(0 0 0 / 13%)"
                bgPos="center"
                bgRepeat="no-repeat"
                color="transparent"
                bgImage={`url('${config.imgPath}/d/46272/1734001134-right_arrow.png')`}
                right="-60px"
                display={currentSlide + 3 === totalSlides ? 'none' : 'block'}
                onClick={currentSlide !== totalSlides - 1 ? onClick : undefined}
            />
        );
    };
    const PrevArrow = props => {
        const { onClick } = props;
        return (
            <Box
                pos="absolute"
                top="38%"
                zIndex="10"
                cursor="pointer"
                bgSize="12px"
                bgColor="#fff"
                border="solid 1px #f4f4f4"
                borderRadius="100%"
                boxShadow="0 0 7px 0 rgb(0 0 0 / 13%)"
                w="62px"
                h="62px"
                bgPos="center"
                bgRepeat="no-repeat"
                color="transparent"
                bgImage={`url('${config.imgPath}/d/46272/1734001138-left_arrow.png')`}
                left={'-80px'}
                display={currentSlide === 0 ? 'none' : 'block'}
                onClick={currentSlide !== 0 ? onClick : undefined}
            />
        );
    };

    const settings = {
        dots: true,
        speed: 100,
        autoplay: false,
        autoplaySpeed: 11000,
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: false,
        infinite: false,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        beforeChange: (oldIndex, newIndex) => setCurrentSlide(newIndex),
        onInit: handleInit,
        appendDots: dots => (
            <Box
                display={{ base: 'block', md: 'block', xl: 'block' }}
                // position="absolute"
                bottom={{ base: '0', md: '0', xl: '0' }}
            >
                <List margin="0px">{dots}</List>
            </Box>
        ),
        responsive: [
            {
                breakpoint: 834,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 1,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                },
            },
        ],
        customPaging: function (i) {
            return (
                <Text
                    cursor="pointer"
                    display="inline-block"
                    w={{ base: '10px', md: '14px' }}
                    h={{ base: '10px', md: '14px' }}
                    m={{ base: '0px', md: '0 8px' }}
                    bgColor="#c4c4c4"
                    borderRadius="50%"
                ></Text>
            );
        },
    };
    return (
        <Box
            id='testimonials-circular-img-slider'
            mx="auto"
            maxW={'1920px'}
            height={{base: '520px', md:'610px'}}
        //   marginTop={{base:'0', "2xl":'-58px'}}
        >
            <Box
                maxW="100%"
                m="0 auto 0 auto"
                overflow="hidden"
                p={{ base: '5px 0px 0 5px', md: '35px 0px 0 0px' }}
                w={{ base: '100%', md: '1920px' }}
            >
                <Slider {...settings} m="0">
                    {sectionContent[1]?.testimonials?.map((data, i) => {
                        return (
                            <Box
                                p={{ base: '0px 12px', md: '0' }}
                                key={nanoid()}
                                textAlign="left"
                                fontFamily={'FedraSerifAStdBook'}
                                fontSize="17px"
                                lineHeight="27px"
                                display="flex"
                                alignItems={'stretch'}
                                margin={{ base: '0 0 30px 0', md: '0' }}
                                flexDirection={'column'}
                                flex={'1'}
                                height={'100%'}
                                className="singlecard"
                                mb={'10px'}
                            >
                                <Box
                                    as="div"
                                    display="flex"
                                    flexDirection="column"
                                    justifyContent="flex-start"
                                    width={{ base: '100%', md: '342px' }}
                                    background={'#FFFFFF'}
                                    boxShadow="0px 3px 3px 0px #0000001A"
                                    minH={{ base: '420px', md: '440px' }}
                                    borderRadius={'6px'}
                                >
                                    <Box as="div" textAlign="center" mt={'30px'}>
                                        <Image
                                            loading="lazy"
                                            src={data?.photo?.url}
                                            width={{ base: '110px', md: '130px' }}
                                            title={data?.photo?.title}
                                            alt={data?.photo?.alt}
                                        />
                                    </Box>
                                    <Box
                                        as="div"
                                        p="10px 20px 0px 20px"
                                        fontFamily={'FedraSerifAStdBook'}
                                        color="#CA4E2A"
                                        fontWeight={'600'}
                                        textAlign={'center'}
                                        fontSize={'22px'}
                                        lineHeight={'144%'}
                                    >
                                        {data?.userName}
                                        </Box>
                                    <Box>                                        
                                    <StructuredTextParser
                                        fontFamily={'FedraSansStd-book'}
                                        color={"#000000"}
                                        str={render(data?.userDescription?.value)}
                                        fontWeight={400}
                                        lineHeight={'144%'}
                                        mt="0px"
                                        fontSize={'16px'}
                                        textAlign={'center'}
                                    />                                   
                                    <StructuredTextParser
                                        fontFamily={'FedraSansStd-book'}
                                        color={"#000000"}
                                        str={render(data?.testimonialText?.value)}
                                        fontWeight={400}
                                        lineHeight={'144%'}
                                        mt="0px"
                                        fontSize={'16px'}
                                        textAlign={'center'}
                                        fontStyle={'italic'}
                                        px={'20px'}
                                    />
                                    </Box>
                                </Box>
                            </Box>
                        );
                    })}
                </Slider>
            </Box>
            <style jsx global>
                {`
            #testimonials-circular-img-slider .slick-dots li p {
              margin-top: 1rem;
              background-color: #FFFFFF;
            }
            #testimonials-circular-img-slider .slick-dots li.slick-active p {
              background-color: #CECECE;
            }
            #testimonials-circular-img-slider .slick-dots {
              position: relative;
              margin-top: 20px;
            }
            #testimonials-circular-img-slider .slick-slider {
              width: 1085px;
              margin: 0 auto;
            }
            #msr-testimonials-group .sharing h2 {
              font-weight: 600;
            }
            #msr-testimonials-group .singlecard {
              display: grid;
              grid-template-rows: auto 1fr auto;
              height: 100%;
            }
            @media (max-width: 321px) {
              #testimonials-circular-img-slider .slick-slider {
                width: 100%;
              }
              #testimonials-circular-img-slider .slick-dots li {
                margin: 0;
              }
              #testimonials-circular-img-slider .slick-prev,
              #testimonials-circular-img-slider .slick-next {
                display: none !important;
              }
              #testimonials-circular-img-slider .slick-list .slick-active {
                width: 290px !important;
              }
              #testimonials-circular-img-slider .slick-dots {
                position: relative;
                margin-top: 10px;
              }
            }
            @media (min-width: 321px) and (max-width: 768px) {
              #testimonials-circular-img-slider .slick-slider {
                width: 100%;
              }
              #testimonials-circular-img-slider .slick-dots li {
                margin: 0;
              }
              #testimonials-circular-img-slider .slick-prev,
              #testimonials-circular-img-slider .slick-next {
                display: none !important;
              }
              #testimonials-circular-img-slider .slick-list .slick-active {
                width: 328px !important;
              }
              #testimonials-circular-img-slider .slick-dots {
                position: relative;
                margin-top: 10px;
              }
            }
          `}
            </style>
        </Box>
    );
};

export default TestimonialsWithCircularImg;